// extracted by mini-css-extract-plugin
export default {"root":"SignIn_root__vfp9o","logo":"SignIn_logo__wgP1w","header":"SignIn_header__7NwN7","body":"SignIn_body__3ljrV","footer":"SignIn_footer__klcJD","divider":"SignIn_divider__+SjLJ"};